import React, { Component, createRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { myLog } from '../../../../utils/Utility';
import store from '../../../../sessionStorage';
import { clearUnreadCount } from '../../../action/SocketActions';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitMessage extends Component {
    static propTypes = {
        closeMessagePop: PropTypes.func,
        onSendMessage: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            textMessage: '',
            chatImage: '',
            file: null,
            isOpen: false,
            popUpImage: '',
            receiverId: '',
            autoScrollToBottom: true,
            isAPICall: false,
            isScrollHeight: 0,
        };
        this.messagesEndRef = createRef();
        this.chatCotainerRef = React.createRef();
    }

    // componentDidMount
    componentDidMount() {
        this.props.clearUnreadCount();
        sessionStorage.setItem('EducatorChatPopup', true);
        this.scrollToBottom();
    }

    // componentWillUnmount
    componentWillUnmount() {
        if (sessionStorage.getItem('EducatorChatPopup') === 'true') {
            this.props.clearUnreadCount();
        }
        sessionStorage.setItem('EducatorChatPopup', false);
    }

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        const isNewMessageArrived = prevProps.chatList.length < this.props.chatList.length;
        if (isNewMessageArrived) {
            if (this.state.isAPICall) {
                const chatCotainer = this.chatCotainerRef.current;
                chatCotainer.scrollTop = chatCotainer.scrollHeight - this.state.isScrollHeight;
            } else {
                this.scrollToBottom();
            }
        } else {
            if (this.autoScrollToBottom) {
                this.scrollToBottom();
            }
        }
    }

    // scrollToBottom
    scrollToBottom = () => {
        const chatCotainer = this.chatCotainerRef.current;
        chatCotainer.scrollTop = chatCotainer.scrollHeight;
    };

    //handleScroll
    handleScroll = () => {
        const chatCotainer = this.chatCotainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatCotainer;
        const enableScroll = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
        if (enableScroll) {
            this.autoScrollToBottom = true;
        } else {
            this.autoScrollToBottom = false;
        }
        if (scrollTop === 0) {
            if (this.props.chatLastPage > this.props.currentChatPage && this.props.chatLastPage) {
                this.props.callChatAPI();
                this.setState({ isAPICall: true, isScrollHeight: scrollHeight });
            }
        } else {
            this.setState({ isAPICall: false });
        }
    };

    autoScrollToBottom = true;

    //sendMessageClicked
    sendMessageClicked = () => {
        const { textMessage, chatImage, receiverId } = this.state;
        if (textMessage.trim() !== '' || chatImage.length !== 0) {
            if (chatImage.length !== 0) {
                this.props.onSendMessage('', chatImage, 1, receiverId);
            } else if (textMessage.length !== 0) {
                this.props.onSendMessage(textMessage, '', 0, receiverId);
            }
            this.resetMessage();
        }
    };

    /**
     *
     */
    resetMessage() {
        this.setState({
            textMessage: '',
            chatImage: '',
            receiverId: '',
        });
    }

    /**
     *
     * @param {*} files
     */
    getFiles(files) {
        this.setState({
            file: URL.createObjectURL(files[0].file),
        });
        let base64Value = '';
        base64Value = files[0].base64;
        this.setState({
            chatImage: base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length),
        });
        myLog('photo', base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length));
        this.sendMessageClicked();
    }

    /**
     *
     * @param {*} isChatLoading
     */
    _renderLoading(isChatLoading) {
        if (isChatLoading) {
            return (
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#FFF',
                    }}
                >
                    <p>{this.props.t('loading')}</p>
                </div>
            );
        }
    }

    /**
     *
     * @param {*} chatList
     * @param {*} userType
     */
    _renderMessage(chatList) {
        let index = 0;
        return (
            <>
                {_.map(chatList, (chat) => {
                    index++;
                    const currentUserId =
                        store.get('userSession')?.id ||
                        store.get('insAdminSession')?.id ||
                        store.get('userId');
                    const receiverUserId = chat.receiverUserId || chat.receiverId || chat.toUserId;
                    const isPrivateMessage = Boolean(
                        chat.privateMessage ?? chat.private ?? chat.privateMessageFlag
                    );
                    const urlParams = new URLSearchParams(window.location.search);
                    const AnonymousUserId = urlParams.get('userId');
                    // Check if the chat object contains the 'messageId' key and messageType is not 2 before rendering the message
                    if (chat.hasOwnProperty('messageId') && chat.messageType !== 2) {
                        if (chat.senderUserId === currentUserId) {
                            return (
                                <div className="flex flex-row-reverse pb-6 md:pb-4" key={index}>
                                    <div className="msg-text">
                                        <div className="p-3 mt-2 text-white break-words rounded bg-black/10">
                                            {/* {isPrivateMessage && (
                                                <span className="mb-1 block text-xs text-UIprimary">
                                                    {this.props.t('directMessage')}
                                                </span>
                                            )} */}
                                            {chat.message.split(/\n/).map((message) => (
                                                <React.Fragment key={message}>
                                                    {message}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        } else {
                            if (
                                (isPrivateMessage &&
                                    (!receiverUserId ||
                                        receiverUserId === currentUserId ||
                                        receiverUserId === AnonymousUserId)) ||
                                !isPrivateMessage
                            ) {
                                return (
                                    <div className="flex pb-6 md:pb-4" key={index}>
                                        <div className="msg-text">
                                            <div className="text-left">
                                                <span
                                                    className="w-32 mr-2 font-medium text-white table-ellipse whitespace-nowrap text-ellipsis"
                                                    title={chat.senderName}
                                                >
                                                    {chat.senderName.length > 15
                                                        ? `${chat.senderName.slice(0, 15)}...`
                                                        : chat.senderName}
                                                    {isPrivateMessage &&
                                                        (!receiverUserId ||
                                                            receiverUserId === currentUserId ||
                                                            receiverUserId === AnonymousUserId) && (
                                                            <span className="text-UIprimary">
                                                                {' '}
                                                                ({this.props.t('directMessage')})
                                                            </span>
                                                        )}
                                                </span>
                                            </div>
                                            <div className="p-3 mt-2 text-white break-words rounded bg-cyan">
                                                {chat.message.split(/\n/).map((message) => (
                                                    <React.Fragment key={message}>
                                                        {message}
                                                        <br />
                                                    </React.Fragment>
                                                ))}
                                                {/* {chat.message} */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                    } else {
                        // Return null if 'messageId' key is not present or messageType is 0 to skip rendering this chat message
                        return null;
                    }
                })}
            </>
        );
    }

    render() {
        const { chatList } = this.props;
        const sessionUsers = this.props.sessionUsers || [];

        const validUsers = (this.props.streams || [])
            .map((user) => sessionUsers.find((e) => e.name === user.name && e.role !== 'ANONYMOUS'))
            .filter(Boolean);
        return (
            <>
                <div className="flex items-center justify-between p-4 bg-card border-bottom">
                    <h6 className="mb-0 text-lg font-semibold text-white">
                        {this.props.t('chat')}
                    </h6>
                    <span
                        className="cursor-pointer"
                        onClick={() => {
                            this.props.closeMessagePop();
                            this.props.clearUnreadCount();
                            sessionStorage.setItem('messageSeen', false);
                        }}
                    >
                        <i className="text-white fal fa-xmark fa-lg"></i>
                    </span>
                </div>

                <div
                    className="h-full pr-1 overflow-y-auto grow bg-card"
                    onScroll={() => this.handleScroll()}
                    ref={this.chatCotainerRef}
                >
                    <div className="flex flex-col w-full p-4 message-area">
                        {this._renderMessage(chatList)}
                        <div
                            style={{ float: 'left', clear: 'both', marginTop: '10px' }}
                            ref={this.messagesEndRef}
                        />
                    </div>
                </div>
                <div className="bg-card">
                    <div className="flex m-4 rounded-lg text-area">
                        <div className="relative flex flex-col message-field">
                            {(this.props.isClassRoom || this.props.isConferenceCall) &&
                                validUsers.length > 0 && (
                                    <div className="flex items-center mb-2">
                                        <span className="mx-2 text-white">
                                            {this.props.t('to')} :
                                        </span>

                                        <select
                                            value={this.state.receiverId}
                                            onChange={(evt) => {
                                                this.setState({ receiverId: evt.target.value });
                                            }}
                                            className="rounded-md py-1.5 px-2 outline-0 text-white bg-card placeholder:text-secondary text-base cursor-pointer"
                                        >
                                            <option value="" className="text-white">
                                                {this.props.t('everyone')}
                                            </option>

                                            {validUsers.map((userDetails, index) => (
                                                <option
                                                    key={index}
                                                    value={userDetails.userId}
                                                    className="w-32 text-white whitespace-nowrap"
                                                    title={userDetails.name}
                                                >
                                                    {userDetails.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            <div className="relative w-full">
                                <textarea
                                    placeholder={this.props.t('startMessageHere')}
                                    id="about"
                                    name="about"
                                    rows="1"
                                    maxLength={255}
                                    className="block w-full rounded-md bg-dateselect border-0 py-1.5 pr-10 pl-2 outline-0 text-white placeholder:text-white resize-none"
                                    value={this.state.textMessage}
                                    onChange={(evt) => {
                                        this.setState({
                                            textMessage: evt.target.value.trimLeft(),
                                        });
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey)
                                            this.sendMessageClicked();
                                    }}
                                ></textarea>
                                <button
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center justify-center bg-[#755FDC] text-white p-2 rounded-full"
                                    onClick={() => {
                                        this.sendMessageClicked();
                                    }}
                                >
                                    <svg
                                        width="15"
                                        height="14"
                                        viewBox="0 0 15 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M4.85502 3.73404L9.73677 2.10679C11.9275 1.37654 13.1178 2.57254 12.3933 4.76329L10.766 9.64504C9.67352 12.9283 7.87952 12.9283 6.78702 9.64504L6.30402 8.19604L4.85502 7.71304C1.57177 6.62054 1.57177 4.83229 4.85502 3.73404Z"
                                            stroke="white"
                                            strokeWidth="1.15"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M6.41309 7.94853L8.47159 5.88428"
                                            stroke="white"
                                            strokeWidth="1.15"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {/* <button
              className="flex items-end px-3 pb-2 bg-[#755FDC] text-white"
              onClick={() => {
                this.sendMessageClicked();
              }}
              onKeyPress={() => {
                this.sendMessageClicked();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 48 48"
                className="text-primary-500"
              >
                <path
                  fill="currentColor"
                  d="M7.262 4.244c-1.787-.893-3.765.812-3.146 2.711L8.13 19.26a2 2 0 0 0 1.573 1.352l15.86 2.643c.835.14.835 1.34 0 1.48L9.704 27.378a2 2 0 0 0-1.573 1.352L4.116 41.042c-.62 1.9 1.359 3.605 3.146 2.712l35.494-17.742c1.659-.83 1.659-3.197 0-4.026L7.262 4.244Z"
                />
              </svg>
            </button> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchtoProps = (dispatch) => {
    return {
        clearUnreadCount: () => {
            dispatch(clearUnreadCount());
        },
    };
};

const ConnectedActiveVisitMessage = withLanguage(
    connect(null, mapDispatchtoProps)(ActiveVisitMessage)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedActiveVisitMessage {...props} />
    </LanguageProvider>
);
